import request from '@/utils/request';
import { exportUrl } from '@/utils/index';

/**
 *  查询推广者用户列表
 */
export function getPromoterList(params) {
  return request({
    url: `/funteach/spreaderCustomers/page`,
    method: 'get',
    params: params
  });
}

/**
 *  推广者用户解绑
 */
export function userPromoterUnbind(id, options) {
  return request({
    url: `/funteach/spreaderCustomers/${id}/unbind`,
    method: 'post',
    data: options
  });
}

/**
 *  更新规则
 */
export function commissionRulesUpdate(options) {
  return request({
    url: `/funteach/commissionRules/update`,
    method: 'post',
    data: options
  });
}

//* **************创建推广者管理*********************** */
/**
 *  推广者用户解绑
 */
export function createSpreadersInfo(options) {
  return request({
    url: `/funteach/spreaders/`,
    method: 'post',
    data: options
  });
}

/**
 *  查询推广者列表
 */
export function getSpreadersList(params) {
  return request({
    url: `/funteach/spreaders/page`,
    method: 'get',
    params: params
  });
}

// 转为推广者
export function translationSpreaders(id) {
  return request({
    url: `/funteach/spreaders/${id}/approve`,
    method: 'post'
  });
}

// 删除推广信息
export function translationRemove(id) {
  return request({
    url: `/funteach/spreaders/${id}/remove`,
    method: 'post'
  });
}

/**
 *  获取推广者保护机制信息
 */
export function getProtectionsInfo() {
  return request({
    url: `/spreader/protections`,
    method: 'get'
  });
}

/**
 *  保存推广者保护机制信息
 */
export function saveProtectionsInfo(options) {
  return request({
    url: `/spreader/protections`,
    method: 'put',
    data: options
  });
}

/**
 *  查询推广订单总计列表
 */
export function getSpreadOrdersList(params) {
  return request({
    url: `/funteach/spreadOrders/page`,
    method: 'get',
    params: params
  });
}

//* ******************佣金规则管理************************** */

/**
 *  查询佣金规则分页列表
 */
export function getCommissionRulesList(params) {
  return request({
    url: `/funteach/commissionRules/page`,
    method: 'get',
    params: params
  });
}

/**
 *  获取佣金规则详情
 */
export function getCommissionRulesDetail(id) {
  return request({
    url: `/funteach/commissionRules/${id}`,
    method: 'get'
  });
}

/**
 *  查询代理等级列表
 */
export function getSpreadersGradesList() {
  return request({
    url: `/funteach/spreaders/agentGrades`,
    method: 'get'
  });
}

/**
 *  创建分润规则
 */
export function createCommissionRules(options) {
  return request({
    url: `/funteach/commissionRules/`,
    method: 'post',
    data: options
  });
}

// 删除佣金规则
export function commissionRulesRemove(id) {
  return request({
    url: `/funteach/commissionRules/${id}/remove`,
    method: 'post'
  });
}

/**
 *  查询打款分页列表
 */
export function getCommissionSettlementsList(params) {
  return request({
    url: `/funteach/commissionSettlements/page`,
    method: 'get',
    params: params
  });
}

/**
 *  查询打款详情
 */
export function getCommissionSettlementsDetail(id) {
  return request({
    url: `/funteach/commissionSettlements/${id}`,
    method: 'get'
  });
}

/**
 *  标记打款
 */
export function markPayment(options) {
  return request({
    url: `/funteach/commissionSettlements/update`,
    method: 'post',
    data: options
  });
}

/**
 *  推广管理-更新身份
 */
export function changeIdentity(options) {
  return request({
    url: `/funteach/spreaders/changeIdentity`,
    method: 'post',
    data: options
  });
}

/**
 *  分润规则-商品列表
 */
export function getProductsList(params) {
  return request({
    url: `/funteach/products/list`,
    method: '',
    params: params
  });
}

// 导出推广者管理
export function exportSpreadersExcel(options) {
  const url = exportUrl(options, '/funteach/spreaders/export');
  return url;
}

// 导出推广者用户管理
export function exportSpreaderCustomersExcel(options) {
  const url = exportUrl(options, '/funteach/spreaderCustomers/export');
  return url;
}

// 导出推广订单总计
export function exportSpreadOrdersExcel(options) {
  const url = exportUrl(options, '/funteach/spreadOrders/export');
  return url;
}

// 导出打款信息
export function exportCommissionSettlementsExcel(options) {
  const url = exportUrl(options, '/funteach/commissionSettlements/export');
  return url;
}

